module.exports = "/_next/static/images/e6d97d096b3cddf87c73f7396ff4f9b5-holding-device-smile@2x.jpg.webp";